<template lang="pug">
  #master-login
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      .container.body-width.w-75.text-center.pt-5
        h2.font-weight-bold.text-muted 管理者用ログイン画面
        b-card.mx-auto.login-box.mt-4(body-class="px-5")
          div(v-if="error_msg_list.length > 0" data-testid="login_errors")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list") {{error_msg}}
          b-form(@submit.prevent="login()")
            b-form-group.mt-4
              b-container
                b-row
                  b-col
                    b-form-input.mt-1(v-model="sub_domain.value", required, placeholder="サブドメイン名", data-testid="input_domain_name", :state="sub_domain.error_msg_list.length === 0 ? null : false")
                  b-col
                    b-form-radio-group.radio-align-left.domain-name-font-size(v-model="sub_domain_radio.value", :checked="sub_domain_radio.options[0].value", :state="sub_domain_radio.error_msg_list.length === 0 ? null : false")
                      b-form-radio(:value="sub_domain_radio.options[0].value") {{sub_domain_radio.options[0].name}}
                      b-form-radio(:value="sub_domain_radio.options[1].value") {{sub_domain_radio.options[1].name}}
              b-form-text.align-left.text-left.error-message-color(v-for="(message) of sub_domain.error_msg_list") {{message}}
              b-form-text.align-left.text-left.error-message-color(v-for="(message) of sub_domain_radio.error_msg_list") {{message}}
            b-form-group.mt-2
              b-form-input.mt-1(v-model="login_id.value", required, placeholder="ログインID", data-testid="input_mail_address", :state="login_id.error_msg_list.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(message) of login_id.error_msg_list") {{message}}
            b-form-group.mt-2
              b-form-input.mt-1(v-model="pwd.value", required, type="password", placeholder="パスワード", data-testid="input_password", :state="pwd.error_msg_list.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color(v-for="(message) of pwd.error_msg_list") {{message}}
            b-button.w-100.mt-4.mb-3(type="submit", variant="primary" data-testid="btn_login", :disabled="isLoginButtonDisabled") ログイン
</template>

<script>
import Api from '@/repositories/api'
import Loading from '@/components/Loading'
const LoginRepository = Api.get('c201Login')
const MasterLoginRepository = Api.get('c201MasterLogin')

export default {
  name: 'MasterLogin.vue',
  components: {
    Loading
  },
  data() {
    return {
      sub_domain: {
        value: '',
        error_msg_list: []
      },
      login_id: {
        value: '',
        error_msg_list: []
      },
      pwd: {
        value: '',
        error_msg_list: []
      },
      sub_domain_radio: {
        value: '0',
        options: [
          { value: '0', name: '.dn-cloud.com' },
          { value: '1', name: '.chatluck.net' }
        ],
        error_msg_list: []
      },
      error_msg_list: [],
      // ログインボタンフラグ
      isLoginButtonDisabled: false,

      // 読み込み中フラグ
      isLoading: false,
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true

    // ログイン済チェック処理
    LoginRepository.check()
    .then((response) => {
      // 社内IPではない場合
      if (response.data.data.is_internal_ip === false) {
        // お客様用ログイン画面へ遷移する
        this.$router.push({name: 'Login'})
      }
      // 既にログインしている場合
      if (response.data.data.is_login === true) {
        // トップページへ遷移する
        this.$router.push({name: 'TopPage'})
      }
    })
    .finally(() => [
      // 読み込み完了
      this.isLoading = false
    ])
  },
  methods: {
    login() {
      // エラーメッセージを初期化する
      this.error_msg_list = []
      this.sub_domain.error_msg_list = []
      this.login_id.error_msg_list = []
      this.pwd.error_msg_list = []
      this.sub_domain_radio.error_msg_list = []

      // ログインボタンをロックする
      this.isLoginButtonDisabled = true

      // リクエストデータの生成
      const params = new URLSearchParams()
      params.append('login_id',         this.login_id.value)         // ログインID
      params.append('pwd',              this.pwd.value)              // パスワード
      params.append('sub_domain',       this.sub_domain.value)       // サブドメイン名
      params.append('sub_domain_radio', this.sub_domain_radio.value) // サブドメイン名プルダウン
      params.append('is_master',   '1')                        // マスタパスワードログインフラグ

      // ログイン処理
      MasterLoginRepository.login(params)
      .then(() => {

        // Cookieにログイン画面の種類（'1':マスタログイン）のフラグをセットする
        this.setCookieOfLoginType('1')

        // トップページへ遷移する
        this.$router.push({name: 'TopPage'})
      })
      .catch((error) => {
        // ログインボタンのロックを解除する
        this.isLoginButtonDisabled = false

        // 共通のエラー処理
        this.apiError(error, 'ログイン処理')

        // 認証失敗時の場合
        if (error.response.data.message) {
          this.error_msg_list.push(error.response.data.message)
        }
        // それ以外の場合
        else {
          for (let errorData of error.response.data.error_list) {
            // 入力エラーではない場合
            if (!errorData.target) {
              // 画面上部にエラーメッセージを表示
              this.error_msg_list.push(errorData.error_msg)

              // 次のエラーメッセージへ
              continue
            }

            // エラーの項目がマスタパスワードフラグの場合
            if (errorData.target === 'is_master') {
              // 画面上部にエラーメッセージを表示
              this.error_msg_list.push(errorData.error_msg)

              // 次のエラーメッセージへ
              continue
            }

            // 対象の入力項目にエラーメッセージを表示
            this[errorData.target].error_msg_list.push(errorData.error_msg)
          }
        }

        // パスワードを空にする
        this.pwd.value = ''
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.login-box {
  width: 550px;
}
</style>